import React, { useReducer, useRef } from 'react';
import useWindowWidth from '../../../hooks/useWindowWidth';

const PageContext = React.createContext({});

// actions
const LOG_IN_USER = 'LOG_IN_USER';
const UPDATE_WINDOW_WIDTH = 'UPDATE_WINDOW_WIDTH';

const globalReducer = (state, action) => {
  switch (action.type) {
    case UPDATE_WINDOW_WIDTH:
      return {
        ...state,
        windowWidth: action.payload
      };
    case LOG_IN_USER:
      return {
        ...state,
        context: {
          ...state.context,
          currentUser: action.payload,
          adminUser: action.payload.admin,
          proUser: action.payload.pro
        }
      };
    default:
      return state;
  }
};

const Page = ({ context, children }) => {
  const [globalState, dispatchGlobalState] = useReducer(globalReducer, { context, windowWidth: null });
  const modalRef = useRef({ current: null });
  const dispatchWindowWidth = payload => {
    dispatchGlobalState({ type: UPDATE_WINDOW_WIDTH, payload });
  };
  useWindowWidth(dispatchWindowWidth);

  return (
    <PageContext.Provider value={{ globalState, dispatchGlobalState, modalRef: modalRef.current }}>
      <div id="modalPortal" ref={modalRef} />
      {children}
    </PageContext.Provider>
  );
};

export { Page, PageContext, LOG_IN_USER };
